import Module from "./Module"

const requireAuth = {requireAuth: true}

const moduleRoute = {
	path: '/detail-penerimaan',
	component: Module,
	children: [
		{
			path: 'outlet/:idoutlet/:tipePembayaran',
			name: "detail-penerimaan-outlet",
			component: () => import('./views/DetailPenerimaan.vue'),
			meta: requireAuth,
			props: (route) => ({
				...route.params
			})
		},
		{
			path: 'listoutlet/:tipe/:periodProps',
			name: "listoutlet",
			component: () => import('./views/ListDetailPendapatanPengeluaran.vue'),
			meta: requireAuth,
			props: (route) => ({
				...route.params
			})
		},
	]
}

export default router => {
	router.addRoutes([moduleRoute])
}